import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  getMemberDetail (params) { // 获取会员资料
    return axios.post(global.MYG_1V1 +'/campaign/findMemberData', params)
  },
  getMemberIntegral(params) { // 获取会员积分记录
    return axios.post(global.MYG_1V1 + '/campaign/findMemberIntegralDetails', params)
  },
  verify1V1 (params) { // 审核1v1
    return axios.post(global.MYG_1V1 + '/campaign/verifyServiceGift', params)
  },
  verifyMillion (params) { // 审核百万罐
    return axios.post(global.MYG_1V1 + '/campaign/verifyDeliver', params)
  },
  addServiceOrder (params) { // 填写工单
    return axios.post(global.MYG_1V1 + '/campaign/insertMemberVisit', params)
  },
  getKnowledge(params) { // 根据月龄段和会员标签查知识库
    return axios.post('http://192.168.9.20:7001/msi/mmc/info/Knowledge/findKlg', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/myg/task.js